'use es6';

export const CRM = 'crm';
export const HUBDB = 'hubdb';
export const HUBDB_SOURCE_TYPE = 1;
export const CRM_SOURCE_TYPE = 2;
export const DATA_QUERY_TYPE = 3;
export const DataSourceTypes = {
  CRM_OBJECT: 'CRM_OBJECT'
};